// Function to update the .consumer__tag-item content based on selected option
function updateTagItem(selectId, tagItemId) {
  const selectElement = document.getElementById(selectId);
  const tagItemElement = document.getElementById(tagItemId);
  const tagTextElement = tagItemElement.querySelector("p");
  const closeIcon = tagItemElement.querySelector(".top__service-submit-icon");

  // Add event listener for changes in the select element
  selectElement.addEventListener("change", function () {
    const selectedOption =
      selectElement.options[selectElement.selectedIndex].text;

    // Show the tag item and update its content
    if (selectedOption !== "") {
      tagItemElement.style.display = "flex"; // Show the tag item
      tagTextElement.textContent = selectedOption;
    }
  });

  // Add event listener to the close icon
  closeIcon.addEventListener("click", function () {
    tagItemElement.style.display = "none"; // Hide the tag item
    selectElement.selectedIndex = 0; // Reset the select option
  });
}

// Update tag items based on select option changes
// updateTagItem("select-1", "tag-item-1"); // For first select and tag item
// updateTagItem("select-2", "tag-item-2"); // For second select and tag item
// updateTagItem('select-3', 'tag-item-3'); // For third select and tag item

document.addEventListener("DOMContentLoaded", function () {
  function getShopNews(data) {
    return new Promise(function (resolve, reject) {
      let body = `action=get_news`;
      if (data.news_type) {
        body += `&news_type=${data.news_type}`;
      }
      if (data.page) {
        body += `&page=${data.page}`;
      }
      fetch(`/wp-admin/admin-ajax.php`, {
        method: "POST",
        body: body,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        // signal: controller.signal,
      })
        .then((response) => response.json())
        .then((data) => {
          resolve(data.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function displayTabContent(tab, page = 1) {
    const tabElement = document.querySelector(
      '.js-tab-content [data-tab="' + tab + '"] .news__list'
    );

    const typesMap = {
      "-all": null,
      "-important": "重要なお知らせ",
      "-topic": "トピック",
      "-recruit": "採用情報",
    };

    let news_type = typesMap[tab] ? typesMap[tab] : null;

    if (tabElement) {
      getShopNews({
        news_type: news_type,
        page: page,
      }).then(function (data) {
        tabElement.innerHTML = "";
        tabElement.innerHTML = data.items;

        const paginationElement = document.querySelector("[data-pagination]");

        paginationElement.innerHTML = "";
        paginationElement.innerHTML = data.pagination;

        const paginationLinks = document.querySelectorAll(
          "[data-pagination] a[data-page]"
        );

        paginationLinks.forEach(function (link) {
          link.addEventListener("click", function (e) {
            e.preventDefault();

            const page = link.dataset.page;

            displayTabContent(tab, page);
          });
        });
      });
    }
  }

  document
    .querySelectorAll("[data-tab-group] [data-tab]")
    .forEach(function (tab) {
      tab.addEventListener("click", function (event) {
        const selectedTab = event.target.dataset.tab;
        displayTabContent(selectedTab);
      });
    });

  const activeTab = document.querySelector(
    "[data-tab-group] [data-tab].-active"
  );

  //   if (activeTab) {
  displayTabContent("-all");
  //   }
});
